import React, { useMemo } from 'react'

import Box from '@mui/material/Box'
import ActionButtons from 'components/common/ActionButtons'
import { useFormikContext } from 'formik'
import { STANDALONE_DELIVERY_TYPE_NAMES } from 'utils/constants'
import isEmptyObject from 'helpers/node/isEmptyObject'
import usePostingNoticeRequestContext from 'hooks/posting_notice_request/usePostingNoticeRequestContext'

function FooterButtons({ ...props }) {
  const { values, dirty, submitForm, resetForm, errors, isSubmitting } =
    useFormikContext()
  const { stage, setStage, reset } = usePostingNoticeRequestContext()

  const footerActionProps = useMemo(() => {
    const { activeIndex, isConfirmModal, onDownload } = props

    const isNextDisabled = () => {
      const optionalKeys = ['name', 'email']
      if (Boolean(STANDALONE_DELIVERY_TYPE_NAMES[activeIndex])) return false

      if (
        Array.isArray(errors) &&
        errors.filter((err) => !isEmptyObject(err)).length > 0
      )
        return true

      if (Array.isArray(values)) {
        for (let i = 0; i < values.length; i++) {
          const valuesEntries = Object.entries(values)

          for (let j = 0; j < valuesEntries.length; j++) {
            const [key, value] = valuesEntries[j]

            if (!optionalKeys.includes(key) && !value) return true
          }
        }
      }

      return false
    }

    if (stage === 0) {
      return [
        {
          children: 'Next',
          color: 'primary',
          variant: 'contained',
          onClick: () => submitForm(),
          disabled: isNextDisabled() || isSubmitting,
        },
        !Boolean(STANDALONE_DELIVERY_TYPE_NAMES[activeIndex]) && {
          children: 'Clear',
          color: 'primary',
          variant: 'outlined',
          onClick: () => {
            resetForm()
            reset()
          },
          disabled: !dirty || isSubmitting,
        },
      ].filter((b) => b)
    }

    if (isConfirmModal) {
      return [
        {
          children: 'Send as Mail',
          color: 'primary',
          variant: 'contained',
          onClick: () => submitForm(),
          disabled: isSubmitting,
        },
        {
          children: 'Download PDF',
          color: 'primary',
          variant: 'outlined',
          onClick: () => onDownload(),
          disabled: isSubmitting,
        },
      ]
    }

    return [
      {
        children: stage === 5 ? 'Submit' : 'Next',
        color: 'primary',
        variant: 'contained',
        onClick: () => submitForm(),
        disabled: isSubmitting,
      },
      {
        children: 'Go Back',
        color: 'primary',
        variant: 'outlined',
        onClick: () => setStage(stage - 1),
        disabled: isSubmitting,
      },
    ].filter((b) => b)
  }, [
    props,
    dirty,
    errors,
    values,
    submitForm,
    resetForm,
    stage,
    setStage,
    isSubmitting,
  ])

  return (
    <Box sx={{ py: stage ? 8 : 4 }}>
      <ActionButtons footer actionProps={footerActionProps} />
    </Box>
  )
}

export default FooterButtons
